module.exports = __webpack_public_path__ + "img/img-7.b57af168.jpg";